import { Button, Checkbox, Form, Modal, Select } from "antd";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import {
  GetDomainList,
  GetGroupsList,
  GetSpecialEmailList,
  axiosErrorMessages,
} from "../../../../API/api";
import axios, { AxiosError } from "axios";

interface FilterEmailListType {
  filterData: any;
  handleFilterClose: (data: boolean) => void;
  handleFilterData: (data: any) => any;
}
interface DomainObj {
  value: number;
  label: string;
}
const FilterEmailList: React.FC<FilterEmailListType> = ({
  filterData,
  handleFilterClose,
  handleFilterData,
}) => {
  const [filterForm] = Form.useForm();
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [domainList, setDomainList] = useState<DomainObj[]>([]);
  const [groupList, setGroupList] = useState<DomainObj[]>([]);
  const [specialEmailList, setSpecialEmailList] = useState<DomainObj[]>([]);

  type FieldType = {
    domains?: [];
    groupId?: [];
    employeeStatus: number;
    routingStatus: 0;
    haveSpecialEmail: boolean;
    specialEmailIds: [];
  };
  useEffect(() => {
    getDomainList();
    fetchGroupsList();
    fetchSpecialEmails();
  }, []);

  // const [isCheckedRouting,setisCheckedRouting] =
  const handleCloseAddEditPopup = () => {
    setIsOpen(false);
    handleFilterClose(true);
  };
  // useEffect(()=>{
  //   setFormData()
  // },[])
  const resetFormData = () => {
    filterForm.resetFields();
    filterForm.setFieldsValue({ status: 1 });
  };
  useEffect(() => {
    setFormData();
  }, []);
  const setFormData = () => {
    filterForm.setFieldsValue({
      // status:filterData.status,
      // domainId:filterData.domains,
      // groupId:filterData.groupId,
      specialEmailList: filterData.specialEmailIds,
    });
  };
  const StatusEnum = {
    ALL: 0,
    ACTIVE: 1,
    RESIGNED: 2,
  };
  const RoutingEnum = {
    ALL: 0,
    ENABLED: 1,
    DISABLED: 2,
  };

  const getDomainList = async () => {
    try {
      setIsLoading(true);
      const response = await GetDomainList();
      const newData = response.data.map((domain: any, index: number) => ({
        value: domain.domain,
        label: domain.domain,
      }));
      setDomainList(newData);
      setIsLoading(false);
    } catch (error: any) {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });

      setIsLoading(false);
    }
  };
  const fetchSpecialEmails = async () => {
    try {
      setIsLoading(true);
      const response = await GetSpecialEmailList();
      const newData = response.data.map((domain: any, index: number) => ({
        value: domain.specialEmailId,
        label: domain.email,
      }));
      setSpecialEmailList(newData);
      setIsLoading(false);
    } catch (error: any) {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });

      setIsLoading(false);
    }
  };

  const fetchGroupsList = async () => {
    try {
      setIsLoading(true);
      const response = await GetGroupsList();
      const newData = response.data.map((groups: any, index: number) => ({
        value: groups.groupId,
        label: groups.groupName,
      }));
      setGroupList(newData);
      setIsLoading(false);
    } catch (error: any) {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });

      setIsLoading(false);
    }
  };

  const handleFilterChange = (data: any) => {
    // filterData = data;
    filterData = {
      // ...filterData,
      employeeStatus: data.employeeStatus ? data.employeeStatus : 1,
      haveSpecialEmail: data.specialEmailIds?.length > 0 ? 1 : 0,
      specialEmailIds: data.specialEmailIds?.length ? data.specialEmailIds : [],
      groupId: data.groupId ? data.groupId : [],
      routingStatus: data.routingStatus,
      domains: data.domains?.length > 0 ? data.domains : [],
    };
    // filterData = {
    //   ...filterData,
    //   employeeStatus:1,
    //   haveSpecialEmail:1
    // }
    handleFilterData(filterData);
    setIsOpen(false);
  };

  return (
    <Modal
      title="Email License Filters"
      open={isOpen}
      onCancel={handleCloseAddEditPopup}
      style={{ marginTop: 60 }}
      footer={null}
      width={600}
    >
      <Form
        name="basic"
        form={filterForm}
        autoComplete="off"
        layout="vertical"
        onFinish={handleFilterChange}
      >
        <Form.Item<FieldType> label="Domain Name" name="domains">
          <Select
            maxTagCount="responsive"
            mode="multiple"
            style={{ width: 300 }}
            placeholder="Select Domain"
            options={domainList}
            showSearch
          />
        </Form.Item>
        <Form.Item<FieldType> label="Group Name(Group Email Id)" name="groupId">
          <Select
            maxTagCount="responsive"
            mode="multiple"
            style={{ width: 300 }}
            placeholder="Select Group"
            options={groupList}
            showSearch
          />
        </Form.Item>
        <Form.Item<FieldType> label="Status" name="employeeStatus">
          <Select style={{ width: 300 }} placeholder="Select Status">
            <option value={StatusEnum.ALL}>All</option>
            <option value={StatusEnum.ACTIVE}>Active</option>
            <option value={StatusEnum.RESIGNED}>Resigned</option>
          </Select>
        </Form.Item>
        <Form.Item<FieldType>
          label="Routing"
          name="routingStatus"
          valuePropName="checked"
        >
          <Select style={{ width: 300 }} placeholder="Select Routing">
            <option value={RoutingEnum.ALL}>All</option>
            <option value={RoutingEnum.ENABLED}>Enabled</option>
            <option value={RoutingEnum.DISABLED}>Disabled</option>
          </Select>
          {/* <Checkbox ></Checkbox> */}
        </Form.Item>
        <Form.Item<FieldType> label="Special Email ID" name="specialEmailIds">
          <Select
            maxTagCount="responsive"
            mode="multiple"
            style={{ width: 300 }}
            placeholder="Select Special Email"
            options={specialEmailList}
            showSearch
          />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button className="pm-btn" type="primary" htmlType="submit">
            Filter
          </Button>
          <Button
            style={{ marginLeft: 16 }}
            className="pm-btn"
            type="primary"
            onClick={resetFormData}
          >
            Reset
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default FilterEmailList;
